import { useQuery } from "@tanstack/react-query";
import { apiListDecisions, buildDecisionsQueryString, type DecisionListRequest } from "@/api/client.js";

/** Prefix for `invalidateQueries` after mutations (matches all filtered decision queries). */
export const decisionsQueryKey = ["decisions"] as const;

export function useDecisionsQuery(params: DecisionListRequest) {
  const cacheKey = buildDecisionsQueryString(params);
  return useQuery({
    queryKey: [...decisionsQueryKey, cacheKey] as const,
    queryFn: () => apiListDecisions(params),
  });
}
